import React, { useState } from 'react'

// Putaway operators never need to act on out_of_stock or archived items —
// those don't belong in a putaway queue. Keep the chip set minimal; add the
// other states back when there's a real use case.
const STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'in_stock', label: 'In stock' }
]

function PutawaySearchBar({ onSubmit, loading = false }) {
  const [q, setQ] = useState('')
  // Default to Draft + In stock — both lifecycle states an operator might
  // be putting away. The parent (Putaway.jsx) mirrors this default for its
  // mount-time auto-search; keep the two in sync.
  const [statuses, setStatuses] = useState(['draft', 'in_stock'])

  function toggleStatus(v) {
    setStatuses(prev => prev.includes(v) ? prev.filter(s => s !== v) : [...prev, v])
  }

  function submit(e) {
    e.preventDefault()
    onSubmit({ q: q.trim(), statuses })
  }

  return (
    <form onSubmit={submit}>
      <div className="card" style={{ marginBottom: 16, padding: 16 }}>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <input
            type="text"
            className="form-input"
            placeholder="Search by title, shopify id, or item id"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            style={{ flex: '1 1 240px', minHeight: 48, fontSize: 16 }}
            autoFocus
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ minHeight: 48, padding: '0 24px' }}
          >
            {loading ? 'Searching…' : 'Search'}
          </button>
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <span className="text-sm text-muted" style={{ marginRight: 4 }}>Status:</span>
          {STATUSES.map(s => {
            const on = statuses.includes(s.value)
            return (
              <button
                key={s.value}
                type="button"
                onClick={() => toggleStatus(s.value)}
                className={on ? 'chip chip--on' : 'chip'}
                style={{
                  minHeight: 44,
                  padding: '8px 14px',
                  borderRadius: 22,
                  border: '1px solid',
                  borderColor: on ? '#1e40af' : '#d1d5db',
                  background: on ? '#dbeafe' : 'white',
                  color: on ? '#1e3a8a' : '#374151',
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 500
                }}
              >
                {s.label}
              </button>
            )
          })}
        </div>
      </div>
    </form>
  )
}

export default PutawaySearchBar
